/**
 * 運営元の X アカウント（@asalabo_r18）への導線（TK-070、ADR-013）。
 *
 * R18 サイトから R18 アカウントへのリンクなので、**年齢認証の内側にだけ**置く。静的 HTML
 * （ページ生成の出力・JS 無効時のフォールバック・`SITE_FOOTER_HTML`）には書かず、
 * クリア後（= 必ず認証後）の下部導線帯と、認証成立後の `.site-footer` へ JS で足す。
 * クローラーは JS を実行しない扱い（TK-069）なので、このリンクを見ない。
 *
 * プレーンな `<a href>` だけで、X の埋め込みウィジェット（外部 JS・iframe）もロゴ画像も
 * 使わない（NFR-001 / NFR-002、CSP を緩めない。ADR-013）。インタースティシャル
 * （FR-022）の横取り対象にもしない — `attachInterstitial` は `Next Stage` にしか掛からない。
 */

import type { SocialConfig } from './promo';

function socialAnchor(config: SocialConfig, className: string): HTMLAnchorElement {
  const link = document.createElement('a');
  link.className = className;
  link.href = config.url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  link.textContent = config.label;
  return link;
}

/**
 * クリア後の下部導線帯へ、不可視のまま先に置く。`Next Stage`・送客導線（FR-018）と
 * 同じく、演出完了（`showNext`）で `social-link--visible` が付いてフェードインする。
 * 場所は最初から確保されるため、可視化でレイアウトシフトは起きない（FR-004 / FR-015）。
 */
export function buildSocialLink(
  outbound: HTMLElement,
  config: SocialConfig,
): HTMLAnchorElement | null {
  if (!config.enabled) return null;
  const link = socialAnchor(config, 'social-link');
  link.title = config.lead;
  outbound.append(link);
  return link;
}

/**
 * 選択画面・404 の `.site-footer` の末尾へ 1 項目足す。年齢認証の成立後に呼ぶこと。
 * フッターが無いページ・無効化時は何もしない。二重に呼んでも 1 つしか足さない。
 */
export function appendSocialToFooter(root: ParentNode, config: SocialConfig): void {
  if (!config.enabled) return;
  const footer = root.querySelector('.site-footer');
  if (footer === null || footer.querySelector('.site-footer-social') !== null) return;
  const item = document.createElement('span');
  item.className = 'site-footer-social';
  item.append(` ｜ ${config.lead}: `, socialAnchor(config, 'site-footer-social-link'));
  footer.append(item);
}
